__turbopack_context__.v({
  "container": "Default-module__6IAEKW__container",
  "content": "Default-module__6IAEKW__content",
  "description": "Default-module__6IAEKW__description",
  "does-not-exist": "Default-module__6IAEKW__does-not-exist",
  "js-has-pseudo": "Default-module__6IAEKW__js-has-pseudo",
  "label": "Default-module__6IAEKW__label",
  "switch": "Default-module__6IAEKW__switch",
  "wrapper": "Default-module__6IAEKW__wrapper",
});
